import React, { useEffect, useRef, useState } from "react";

const Loader = ({ ready, minDuration = 1000, fadeDuration = 300 }) => {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(true);
  const [fade, setFade] = useState(false);
  const startTs = useRef(Date.now());
  const rafId = useRef(null);

  // progression fake: plafonne à 99% tant que !ready, accélère vers 100 quand ready
  useEffect(() => {
    const tick = () => {
      setProgress((p) => (!ready ? Math.min(p + 0.8, 99) : Math.min(p + 2, 100)));
      rafId.current = requestAnimationFrame(tick);
    };
    rafId.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId.current);
  }, [ready]);

  // coupe l'anim quand le loader n'est plus visible
  useEffect(() => {
    if (!visible && rafId.current) cancelAnimationFrame(rafId.current);
  }, [visible]);

  // bloque le scroll tant que visible
  useEffect(() => {
    if (visible) document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, [visible]);

  // ne déclenche le fade qu'après minDuration (depuis le montage) ET quand ready === true
  useEffect(() => {
    if (!ready) return;
    const elapsed = Date.now() - startTs.current;
    const remaining = Math.max(0, minDuration - elapsed);

    const t1 = setTimeout(() => {
      setProgress(100);     // affiche 100% avant de commencer le fade
      setFade(true);        // lance la transition CSS
      const t2 = setTimeout(() => setVisible(false), fadeDuration); // retire du DOM après la transition
      return () => clearTimeout(t2);
    }, remaining);

    return () => clearTimeout(t1);
  }, [ready, minDuration, fadeDuration]);

  if (!visible) return null;

  return (
    <div
      className={`loader-overlay ${fade ? "fade-out" : ""}`}
      role="status"
      aria-live="polite"
      aria-busy={!ready}
    >
      <div className="loader-content">
        <div className="loader-box">
          <div className="container-loader">
            <ul className="loader">
              <li className="loader-li loader-li1" />
              <li className="loader-li loader-li2" />
              <li className="loader-li loader-li3" />
              <li className="loader-li loader-li4" />
              <li className="loader-li loader-li5" />
              <li className="loader-li loader-li6" />
            </ul>
          </div>
          <h1>Loading… {progress.toFixed(0)}%</h1>
        </div>
      </div>
    </div>
  );
};

export default Loader;
